import { ReactNode } from 'react';
import { PATH } from '../../constants';
import { useModal } from '../../hooks/useModal';
import { me } from '../../test.data';
import { IconType } from '../../types/icon.type';
import { TextColor } from '../../types/text.type';
import Button from '../button/v2/button';
import Container from '../containers/container';
import { HStack } from '../layouts/stack.layout';
import { IconTextGroup } from '../typography/v2/icon-text-group';
import Text from '../typography/v2/text';
import LinkToItem from '../utility/link-to-item';

type NavigationItem = 'subscriptions' | 'collections' | 'help & support';

type Props = {
  icon: IconType;
  color?: TextColor;
};

type LIProps = Props & {
  text: NavigationItem;
};

type LLProps = Props & {
  text: NavigationItem | 'logout';
  onClick?: Function;
};

function NavigationItemStack({ children }: { children: ReactNode }) {
  return (
    <HStack
      extensions="w-full w-full px-5 py-6 border-b border-dark-gray"
      justify="center"
    >
      {children}
    </HStack>
  );
}

const PATH_FOR_NAV_ITEM: { [key in NavigationItem]: string } = {
  subscriptions: PATH.SUBSCRIPTIONS,
  collections: PATH.COLLECTIONS,
  'help & support': PATH.HELP,
};

function MobileProfileListLink(props: LIProps) {
  return (
    <a className="w-full" href={`/${PATH_FOR_NAV_ITEM[props.text]}`}>
      <MobileProfileListItem text={props.text} icon={props.icon} />
    </a>
  );
}

function MobileProfileListItem(props: LLProps) {
  return (
    <Container extensions="w-full" onClick={props.onClick}>
      <NavigationItemStack>
        <IconTextGroup
          iconFirst
          variant="mobile-navigation"
          iconSize="base"
          icon={props.icon}
          text={props.text}
          gap="base"
          iconColor={props.color}
        />
      </NavigationItemStack>
    </Container>
  );
}

export default function MobileProfileList({ close }: { close: Function }) {
  const { displayName, username } = me;
  const [openEditProfileModal] = useModal('EDIT_PROFILE');
  return (
    <Container extensions="absolute w-full top-0 bottom-0 fixed overflow-auto">
      <NavigationItemStack>
        <a className="w-full" href={`/${username}`}>
          <Text align="center" variant="username" text={displayName} />
        </a>
      </NavigationItemStack>
      <NavigationItemStack>
        <Button
          size="sm"
          variant="outline"
          text="edit profile"
          onClick={() => {
            close();
            openEditProfileModal();
          }}
        />
      </NavigationItemStack>
      <MobileProfileListLink text="subscriptions" icon="subscriptions" />
      <MobileProfileListLink text="collections" icon="collections" />
      <MobileProfileListLink text="help & support" icon="help" />
      <MobileProfileListItem text="logout" icon="logout" />
      <HStack
        extensions="w-full items-center relative bottom-[-80px]"
        justify="center"
        gap="sm"
      >
        <LinkToItem
          variant="supplementary"
          text="Privacy"
          path={PATH.PRIVACY}
        />
        <Text color="info">·</Text>
        <LinkToItem variant="supplementary" text="Terms" path={PATH.TERMS} />
        <Text color="info">·</Text>
        <Text variant="supplementary">© Holdr 2022</Text>
      </HStack>
    </Container>
  );
}
